<script lang="ts">
  import { getContext } from 'svelte';
  import { drawerContextKey, type DrawerContext } from '@athena-lib/Header';
  import type { LinkProps } from './types';
  import { getExternalLinkAttributes } from './utils';

  const drawerContext = getContext<DrawerContext>(drawerContextKey);

  const { href, isExternal, children, onClick, ...restProps }: LinkProps = $props();

  function onClickListener(e: MouseEvent) {
    if (onClick) {
      onClick(e);
    }

    if (drawerContext && !isExternal) {
      e.stopPropagation();
      e.preventDefault();
      drawerContext.close();

      // Timeout because .close() will trigger a browser back, and also
      // to let the drawer animation finish
      setTimeout(() => {
        if (href) {
          drawerContext.navigate(href);
        }
      }, 50);

      return false;
    }
  }

  const useUnderline = $derived.by(() => {
    return (
      restProps.class?.includes('text-st-blue-600') || restProps.class?.includes('text-st-gray-600')
    );
  });
</script>

{#snippet renderChildren()}
  {#if children}
    {#if typeof children === 'string'}
      {children}
    {:else}
      {@render children()}
    {/if}
  {/if}
{/snippet}

{#if href}
  <a
    {...restProps}
    class:underline={useUnderline}
    {href}
    {...isExternal ? getExternalLinkAttributes() : {}}
    onclick={onClickListener}
  >
    {@render renderChildren()}
  </a>
{:else}
  <span {...restProps}>
    {@render renderChildren()}
  </span>
{/if}
